import React from 'react';
import '../globals.css';
import './globals.css';

export const InfoSchema = (React.FC = () => <></>);
export default InfoSchema;
